import Vue from 'vue';
import Buefy from 'buefy';
import VueMoment from 'vue-moment';
import moment from 'moment/moment';
import PrettyCheckbox from 'pretty-checkbox-vue';
import 'moment/locale/fr';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
  faArrowUp, faArrowDown, faAngleRight, faAngleLeft, faAngleDown, faEuroSign,
  faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload,
  faTrash, faFileWord, faFile, faPrint, faBookmark,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueVirtualScroller from 'vue-virtual-scroller';
import App from './App.vue';
import router from './router';
import store from './store';

import 'buefy/dist/buefy.css';
import './assets/css/global.css';
import './assets/css/buefy.override.scss';
import 'pretty-checkbox/src/pretty-checkbox.scss';


library.add(faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
  faArrowUp, faArrowDown, faAngleRight, faAngleLeft, faAngleDown,
  faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload, faTrash, faFileWord, faFile, faPrint,
  faBookmark, faEuroSign);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(PrettyCheckbox);

Vue.config.productionTip = false;
Vue.use(Buefy, {
  defaultIconPack: 'fas',
  defaultIconComponent: 'font-awesome-icon',
});
Vue.use(VueMoment, { moment });
Vue.use(VueVirtualScroller);


Vue.filter('highlight', (stringToSearch, searchTerm) => {
  if (searchTerm === '') return stringToSearch;
  const iQuery = new RegExp(searchTerm, 'ig');
  return stringToSearch.toString().replace(iQuery,
    (matchedText) => (`<span class='highlight'>${matchedText}</span>`));
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
